/**
 * EL CATALOGO DE EQUIPOS ES UNA MAQUETA Y LO DICE (PANEL-EQUIPOS-AVISO-T1, ASSIGN #15802).
 *
 * DE DONDE SALE. #/equipos y la seccion "Catalogo de equipos asignados" de la ficha del
 * negocio corren sobre EquiposCatalogApiClient, un MOCK en memoria desde abril:
 * /api/v1/equipment no existe (404, medido 16-sep) y lo que se crea o asigna se pierde al
 * recargar. Solo lo decia una etiqueta chica con jerga ("API mock -- pendiente backend").
 *
 * LA REGLA: mientras EquiposCatalogApiClient.ES_MAQUETA sea true, las dos pantallas muestran
 * un aviso claro y los botones que registran, asignan o borran quedan deshabilitados con el
 * mismo mensaje. Leer (listar, historial) sigue. El catalogo real llega con EQUIPOS-API-T1 (A)
 * y EQUIPOS-PANEL-T1 (P): ese dia la llave pasa a false y todo vuelve a funcionar sin tocar
 * las vistas.
 *
 * Sin DOM: lo prueba scripts/check-equipos-maqueta.mjs.
 */

export const MENSAJE_MAQUETA = 'Esta pantalla es una maqueta: lo que registres aquí no se guarda todavía.';

/** El aviso, o nada si ya no es maqueta. Solo un true lo enciende. */
export function avisoDeMaqueta(esMaqueta) {
  if (esMaqueta !== true) return '';
  return `<div data-eq-maqueta role="note" style="margin:0 0 12px;padding:10px 14px;font-size:0.875rem;line-height:1.4;color:#f0b72f;background:#d299221a;border:1px solid #d29922;border-radius:8px">⚠ ${MENSAJE_MAQUETA}</div>`;
}

/**
 * Atributos para un boton que registra, asigna o borra: deshabilitado con el mensaje.
 * Si el boton tiene su propio title, se pasa aqui: dos atributos title en la misma etiqueta
 * dejan solo el primero, y el aviso no se veia (medido en el navegador el 16-sep).
 */
export function accionDeMaqueta(esMaqueta, tituloNormal = '') {
  if (esMaqueta === true) return ` disabled aria-disabled="true" title="${MENSAJE_MAQUETA}"`;
  return tituloNormal ? ` title="${String(tituloNormal).replace(/"/g, '&quot;')}"` : '';
}
